import React from 'react';
import Hero from '../components/Hero';
import TradingSteps from '../components/TradingSteps';
import Services from '../components/Services';
import About from '../components/About';
import AccountTypes from '../components/AccountTypes';
import { usePageMeta } from '../hooks/usePageContent';

const Home = () => {
  // Manage page meta data
  usePageMeta('home', {
    title: 'RiverPrime - Premier Forex & CFD Trading',
    metaDescription: 'Trade Forex, Indices, Commodities, and Shares with RiverPrime. Advanced trading platforms, competitive spreads, and professional support.'
  });

  return (
    <div className="home home-page">
      <Hero />
      <TradingSteps />
      <Services />
      <About />
      <AccountTypes />
    </div>
  );
};

export default Home;